module.exports = __webpack_public_path__ + "static/img/membership_global.fd9bf2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/membership_global.png
// module id = BbLl
// module chunks = 1